<template>
    <div  class="popup"  v-if="viewBackupShow" v-cloak>
          <div class="content" id='viewSourceFile'>
              <div class="title">
               Original
              <div class="icon white-close dialog-close" @click="close()"></div>
              </div>
                  <div class="viewSourceFile-body">
                       <div class="backup-list" v-for="(item, index) in sourceData.data" :key="index" @click.stop="toSource(item)">
                              <div class="item-formicon small-file folder-small" ></div>
                              <div style="marginLeft:10px;float:left;cursor:pointer;" :title="item.path" class="backup-url">{{item.path}}</div>
                       </div>
                 </div>
                 <button style="float:right;marginRight:20Px;width:100Px;marginTop:5px;"  @click="close()">  {{$t('language.common.ok')}}</button>
          </div>
          
  </div>
</template>

<script>
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
      data:function(){
          return{
              viewBackupShow:false,
              model:[],
              sourceData:[],
              allDriveIds:[],
              modelList:[],//将数据封装成列表的形式
          }
      },
      methods: {
          close(){
              this.viewBackupShow=false;
          },
          packModelList(){
           if(this.sourceData.data &&this.sourceData.data.length){
             var data = this.sourceData.data;
             var pathArr=[];
             for (let index = 0; index < data.length; index++) {
                 const element = data[index];
                 var nodes = element.nodes;
                 if(nodes[0].filename.indexOf('.')!=-1){
                     nodes.splice(0,1);
                 }
                 var path = nodes[nodes.length-1].filename;
                 if(nodes.length-2 >= 0){
                 for (let i = nodes.length-2; i>=0; i--) {
                     const node = nodes[i];
                     path = path + "\\" + node.filename;
                 }
                 }
                 if(!pathArr.includes(path)){
                    pathArr.push(path);
                    element.path = path;
                 }else{
                     this.sourceData.data.splice(index,1);
                     index--;
                 }
             }
            
           }
          },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        toSource(item){
            item.fileId = item.nodes[0].fileId;
            item.filename = item.nodes[0].filename;
            this.$parent.$refs.singleTask[0].toSourceCatalog(item);
            this.viewBackupShow=false;
        }

      },
      watch:{
        viewBackupShow(newValue,oldValue){
            if(newValue){//当该弹窗显示时
            this.packModelList();
            }
        },
      },
      mounted(){
        
         
      }, 
     
      
}
</script>

<style>
#viewSourceFile{
    width: 450Px;
    height: 380Px;
}
.viewSourceFile-body {
    width: 100%;
    height: 295Px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #6f7886;
    font-size: 14Px;
    float: left;
    overflow: auto;
    padding: 18Px;
}
#viewSourceFile ul {
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 15px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

#viewSourceFile li {
    list-style: none;
    min-width: 420px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
}

#viewSourceFile .tree-node-div{
    word-break: keep-all;
    white-space: nowrap;
    min-width: 420px;
    /*no*/
    height: 40px;
    /*no*/
    overflow: hidden;
}
.viewSourceFile-body::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8Px;
    /* 给滚动条一个最小的高度 */
    background-color: #fff;
}

.viewSourceFile-body::-webkit-scrollbar-thumb {
    min-height: 40px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}
.backup-list{
    width:410Px;
    height:40Px;
    border:1Px solid #f1f6fd;
    margin-bottom: 10Px;
    line-height: 40Px;
    cursor: pointer;
    color: #adb2b9;
}
.backup-list:hover{
    width:410Px;
    height:40Px;
    border:1Px solid #b3bcf6;
    margin-bottom: 10Px;
    line-height: 40Px;
    cursor: pointer;
}
.backup-url {
    color: #adb2b9;
    width: 350px;
    /*no*/
    text-align: left;
    font-size: 14px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 40px;
    /*no*/
    margin-left: 10px;
    /*no*/
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/restore_aim_more_popup.vue